








import {Component, Prop, Vue} from "vue-property-decorator";

import ControlWrapper from "@share/common/ControlWrapper.vue";

@Component({ components: { ControlWrapper } })
export default class FilterButton extends Vue {
    @Prop({ required: true }) selected: boolean;
    @Prop({ default: "" }) title: string;
    @Prop({ default: 'regular' }) size: 'regular' | 'small'

}
